import { React, useState } from 'react'
import "../../../styles/login/loginAndRegister.css"
import Logo from '../../Reutilizables/Logo'
import Footer from '../../Reutilizables/Footer'
import TituloImpuestosMunicipales from "../../Reutilizables/TituloImpuestosMunicipales"
import Redes from '../../Reutilizables/Redes'

import firebaseApp from "../../firebase/Credenciales"
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth"
import {getFirestore, doc, setDoc} from "firebase/firestore"
const auth = getAuth(firebaseApp)

function Login() {

	const firestore = getFirestore(firebaseApp)
	const [isRegistrando, setIsRegistrando] = useState(false)

	async function registrarUsuario(email, password, usuarioNombre) {
		const infoUsuario = await createUserWithEmailAndPassword(
		  auth,
		  email,
		  password
		  ).then((usuarioFirebase)=>{
		  return usuarioFirebase
		})
	
		console.log(infoUsuario.user.uid);
		const docuRef = doc(firestore, `usuarios/${infoUsuario.user.uid}`)
		setDoc(docuRef, {correo: email, usuarioNombre: usuarioNombre})
	  }
	
	  const submitHandler = (e) => {
		e.preventDefault()
	
		const email = e.target.elements.email.value
		const password = e.target.elements.password.value
		const usuarioNombre = e.target.elements.usuarioNombre.value
	
		console.log("submit", email, password, usuarioNombre);
		registrarUsuario(email, password, usuarioNombre)
	  }

	  const redirectToInicio = () => {

		setIsRegistrando(!isRegistrando)

			setTimeout(() => {
			  window.location.href = "/";
			}, 5000);
		  
	  }

  return (
    <div className='container-main'>
      <div className='container-logo-menu-login'> 
    	<Logo />
		<div className='titulo-impuesto-login-register'>
	  		< TituloImpuestosMunicipales />
	 	</div>
      </div>
      <div className="main">
			  <div className="signup">
				  <form onSubmit={submitHandler}>
					  <label className='label-login' aria-hidden="true">Crear cuenta</label>
					  <input className='input-login' id='usuarioNombre' type="usuarioNombre" autoComplete='username' name="txt" placeholder="Nombre de usuario" required/>
					  <input className='input-login' id='email' type="email" autoComplete='email' name="email" placeholder="Correo" required/>
					  <input className='input-login' id='password' type="password" autoComplete='off' name="pswd" placeholder="Contraseña" required/>
					  <button onClick={redirectToInicio} className='button-login'>
						Regístrese
					  </button>			
				  </form>
			  </div>
	    </div>
		<Redes />
		<Footer />
    </div>
  )
}

export default Login
